import { render, staticRenderFns } from "./PopupWithBtn.vue?vue&type=template&id=19fe6562&"
import script from "./PopupWithBtn.vue?vue&type=script&lang=js&"
export * from "./PopupWithBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports